import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export class DateUtil {
  /**
   * Converts a local date (Date object) to UTC (Date object)
   */
  static localDateToUTC(date: Date): Date {
    const localDate = dayjs(date).startOf('day');
    return dayjs.utc(localDate.format('YYYY-MM-DD')).toDate();
  }

  /**
   * Converts a UTC date (Date object) to local (Date object)
   */
  static utcDateToLocal(date: Date): Date {
    const utcDate = dayjs.utc(date).startOf('day');
    return dayjs(utcDate.format('YYYY-MM-DD')).toDate();
  }

  /**
   * Converts a local datetime (Date object) to UTC (Date object)
   */
  static localDateTimeToUTC(date: Date): Date {
    return dayjs(date).utc().toDate();
  }

  /**
   * Converts a UTC datetime (Date object) to local (Date object)
   */
  static utcDateTimeToLocal(date: Date): Date {
    return dayjs.utc(date).local().toDate();
  }

  static roundTimeUpTo(ms: number, coeff: number): number {
    const roundToMs = coeff * 60 * 1000;
    return Math.ceil(ms / roundToMs) * roundToMs;
  }

  static formatUnix = (ts: number | null | undefined): string => {
    if (!ts) return 'N/A';
    return new Date(ts * 1000).toLocaleString();
  };

  static timeStampToBE(timestamp: string) {
    return new Date(timestamp).toLocaleString('nl-BE', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
  }
}
